const _subscribe = (function () {
  class Sub {
    constructor() {
      this.subList = [];
    }
    subscribe(eventName, func) {
      const idx = this.subList.findIndex((sub) =>
        sub.hasOwnProperty(eventName)
      );
      if (idx > -1) {
        this.subList[idx][eventName].push(func);
      } else {
        this.subList.push({ [eventName]: [func] });
      }
    }
    fire(eventName, data) {
      const subList = this.subList;
      for (let i = 0; i < subList.length; i++) {
        const item = subList[i];
        if (!item[eventName]) break;
        item[eventName].forEach((env) => {
          env.call(this, data);
        });
      }
    }
    unsubscribe(eventName) {
      let subList = this.subList;
      const idx = subList.findIndex((sub) => sub.hasOwnProperty(eventName));
      if (idx > -1) {
        subList.splice(idx, 1);
      }
    }
  }

  return function () {
    return new Sub();
  };
})();

export const sub = _subscribe();
